module.exports = __webpack_public_path__ + "static/media/MI theater.a8c19ddb.jpg";